import _, { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ProcessStartForm } from 'src/components/ProcessStartForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { Router } from 'src/core/router/Router';
import { ProcessStoreProvider } from 'src/stores/ProcessStore/ProcessStore';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';

export type EntityProcessProps = {
    store: BasicStore<any>;
    entityListUrl: string;
};

type EntityProcessRouteMath = { entityId: string; processKey: string };

export const EntityProcess = observer(
    ({ store, entityListUrl }: EntityProcessProps) => {
        const { params } = useRouteMatch<EntityProcessRouteMath>();
        const { entityId, processKey } = params;
        const process = ProcessStoreProvider.getInstance(processKey);

        const processContext = _.merge(store.currentItem, process.getContext);

        useEffect(() => {
            if (!entityId || !process) {
                return;
            }
            store.loadItem(entityId);

            return () => {
                process.clearContext();
            };
        }, [entityId]);

        const targetUrl = isNil(entityId)
            ? entityListUrl
            : `${entityListUrl}/${entityId}`;

        if (store.itemLoader.isLoading) {
            return <SpinnerFullWidth />;
        }

        return (
            <ProcessStartForm
                processKey={processKey}
                key={`${entityId}-process`}
                context={processContext}
                onSubmit={() => {
                    store.loadList();
                    Router.navigate(targetUrl);
                }}
                onCustomEvent={(event) => {
                    if (
                        event.type === 'navigateToEntityCard' ||
                        event.type === 'cancel'
                    ) {
                        event.event.preventDefault();
                        Router.navigate(targetUrl);
                    }
                }}
            />
        );
    },
);
